// extracted by mini-css-extract-plugin
export var dropdownContainer = "_r1-0";
export var leftAlign = "_r1-4";
export var listItem = "_r1-2";
export var listItemWrapper = "_r1-1";
export var operationText = "_r1-3";